module.exports = __webpack_public_path__ + "img/Arrow-Down.bb351ff4.svg";